<!-- 添加筛选词 -->
<template>
    <div>
        <span style="color: red">后端响应的列表与分页器不符合</span>
        <!-- 筛选栏 -->
        <el-form :inline="true" v-model="menuselect">
            <!-- 选择类别 -->
            <el-form-item label="">
                <el-select v-model="menuselect.keywordType" filterable clearable placeholder="选择类别" style="min-width: 160px">
                    <el-option v-for="item in cateList" :key="item.id" :label="item.descDescribe" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-input v-model="menuselect.descDescribe" clearable placeholder="选择筛选词"> </el-input>
            </el-form-item>

            <el-form-item style="width: 160px">
                <el-button type="primary" @click="getfilterwordcheckList">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 数据展示 -->
        <el-table :data="filterwordcheckList">
            <!-- id -->
            <el-table-column v-if="false" label="id" min-width="200px">
                <template #default="scope">
                    {{ scope.row.id }}
                </template>
            </el-table-column>
            <!-- 编号 -->
            <el-table-column label="编号" max-width="100px">
                <template #default="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <!-- 关键字 -->
            <el-table-column label="关键字" min-width="100px">
                <template #default="scope">
                    {{ scope.row.descDescribe }}
                </template>
            </el-table-column>
            <!-- 类别 -->
            <el-table-column label="类别" min-width="200px">
                <template #default="scope">
                    <div style="display: flex">
                        <el-select
                            v-if="scope.row.opercolvisible"
                            style="width: 200px"
                            v-model="scope.row.keywordType"
                            filterable
                            clearable
                            :placeholder="scope.row.keywordTypeName ? scope.row.keywordTypeName : '默认'">
                            <el-option v-for="item in cateList" :key="item.id" :label="item.descDescribe" :value="item.id" />
                        </el-select>
                        <span v-else>{{ scope.row.keywordTypeName ? scope.row.keywordTypeName : "默认" }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" header-align="center" align="center" min-width="100px">
                <template v-slot="scope">
                    <el-button type="warning" @click="addtotask(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 页码栏 -->
        <div class="keywordadddialog" style="display: flex; justify-content: center">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[2, 10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="alltotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "keywordAddtotaskView",
        created() {},
        data() {
            return {
                wwe: "",
                cateInitURL: "/api/DescDescribe/init",
                getfilterwordcheckListURL: "/api/DescDescribe/queryDataByParam",
                sendaddwordURL: "/api/DescDescribe/insert",
                sendupdatewordURL: "/api/DescDescribe/update",
                delwordURL: "/api/DescDescribe/delete",

                props: {
                    multiple: true,
                    label: "paramValue",
                    value: "看后端传来的",
                },

                cateList: [],
                filterwordcheckList: [],
                // 筛选条件
                menuselect: {
                    descDescribe: "",
                    keywordType: "",
                },

                // 添加筛选词
                addkeywordinfo: {},

                // 当前页码
                pageNo: 1,
                // 默认每页显示条目数
                pageSize: 5,
                // 总数
                alltotal: 1,

                // 新增筛选词弹窗
                addkeyworddialogVisible: false,
                //  类别维护弹窗
                catemaintaindialogTableVisible: false,
                // 新增类别
                addcatedialogVisible: false,

                addwordrules: {
                    descDescribe: [{ required: true, message: "请填写筛选词的名称", trigger: "blur" }],
                },
            };
        },
        methods: {
            addtotask(row) {
                this.$emit("listenkeywordadd", row);
            },

            //  标签页初始化
            nowtabInit() {
                this.clearMenuSelect();
                this.getmenuSelect();
                this.getfilterwordcheckList();
            },

            clearMenuSelect() {
                this.menuselect = {};
            },

            getmenuSelect() {
                axios
                    .get(this.cateInitURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {},
                    })
                    .then((res) => {
                        this.cateList = res.data.data;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            getfilterwordcheckList(keyType) {
                let requestData = {
                    ...this.menuselect,
                    ...(keyType === -1 ? { keywordType: "-1" } : {}),
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                };

                axios
                    .get(this.getfilterwordcheckListURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: requestData,
                    })
                    .then((res) => {
                        this.filterwordcheckList = res.data.data.result;
                        this.alltotal = res.data.data.total;
                        if (this.filterwordcheckList.length > 0) {
                        } else {
                            this.$message({
                                type: "error",
                                message: "没有相关数据,请重新查询!",
                            });
                        }
                        // this.clearMenuSelect();
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // //改变页数
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getfilterwordcheckList();
            },

            // // 改变条数
            handleSizeChange(val) {
                this.pageSize = val;
                this.getfilterwordcheckList();
            },
        },
        watch: {},
        computed: {},
        created() {
            this.nowtabInit();
        },
        mounted() {},
    };
</script>

<style lang="scss" scoped>
    :deep(.keywordadddialog > .el-pagination > .is-first) {
        color: #000000;
    }

    :deep(.keywordadddialog .el-pagination__goto) {
        color: #000000;
    }

    :deep(.keywordadddialog .el-pagination__classifier) {
        color: #000000;
    }
</style>
